"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = {
    key: 0,
    class: "flex justify-center items-center p-8"
};
const _hoisted_2 = { class: "spinner" };
const _hoisted_3 = {
    key: 1,
    class: "p-2"
};
const _hoisted_4 = { class: "px-6 py-2" };
const _hoisted_5 = { class: "relative" };
const _hoisted_6 = /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "absolute left-8 top-0 bottom-0 w-0.5 bg-blue" }, null, -1);
const _hoisted_7 = /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "absolute left-6 w-5 h-5 bg-blue rounded-full border-4 border-white shadow" }, null, -1);
const _hoisted_8 = { class: "ml-16 bg-white border border-gray-dark rounded-lg p-4 shadow-sm hover:shadow-md transition-shadow" };
const _hoisted_9 = { class: "flex justify-between items-start" };
const _hoisted_10 = { class: "font-semibold text-lg" };
const _hoisted_11 = { class: "text-sm text-gray-darker font-bold" };
const _hoisted_12 = {
    key: 2,
    class: "p-4"
};
const i18n_1 = require("../../common/i18n");
exports.default = (0, vue_1.defineComponent)({
    __name: 'OrderTrackingInfos',
    props: {
        uniqueTrackingData: null,
        trackingDataLoading: { type: Boolean }
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (__props.trackingDataLoading)
                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                    (0, vue_2.createElementVNode)("div", _hoisted_2, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('loading', 'Loading', 'order_tracking_infos')) + " ...", 1)
                ]))
                : (__props.uniqueTrackingData && __props.uniqueTrackingData.length > 0)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_3, [
                        (0, vue_2.createElementVNode)("div", _hoisted_4, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('packing_slip_id', 'Packing Slip ID', 'order_tracking_infos')) + ": " + (0, vue_2.toDisplayString)(__props.uniqueTrackingData[0].packingSlipId), 1),
                        (0, vue_2.createElementVNode)("div", _hoisted_5, [
                            _hoisted_6,
                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(__props.uniqueTrackingData, (item, index) => {
                                return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                    key: item['@id'],
                                    class: "relative mb-8 last:mb-0"
                                }, [
                                    _hoisted_7,
                                    (0, vue_2.createElementVNode)("div", _hoisted_8, [
                                        (0, vue_2.createElementVNode)("div", _hoisted_9, [
                                            (0, vue_2.createElementVNode)("div", _hoisted_10, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)(item.status, item.status, 'order_tracking_infos')), 1),
                                            (0, vue_2.createElementVNode)("div", _hoisted_11, (0, vue_2.toDisplayString)(new Date(item.timeStamp).toLocaleString()), 1)
                                        ])
                                    ])
                                ]));
                            }), 128))
                        ])
                    ]))
                    : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_12, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)('no_tracking_data', 'No tracking data available', 'order_tracking_infos')), 1));
        };
    }
});
